import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type Toggle = { mode: "IDLE" | "SENDING" | "SUCCESS" | "ERROR"; data: string };
const initialState: Toggle = { mode: "IDLE", data: "" };

const toggleSlice = createSlice({
  name: "toggle",
  initialState,
  reducers: {
    setToggleData: (state: Toggle, action: PayloadAction<Toggle>) => ({
      ...state,
      ...{
        mode: action.payload.mode ?? state.mode,
        data: action.payload.data ?? state.data,
      },
    }),
  },
});

export const { setToggleData } = toggleSlice.actions;

export default toggleSlice.reducer;
